class SizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleSelect = this.handleSelect.bind(this)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleOpen)
    })

    this.externalEls?.close?.elements.forEach((closeEl) => {
      this.listeners.add(closeEl, 'click', this.handleClose)
    })

    if (this.externalEls?.select?.element) {
      this.listeners.add(
        this.externalEls.select.element,
        'change',
        this.handleSelect,
      )
    }
  }

  handleOpen () {
    this.externalEls.modal.element.showModal()
    document.body.classList.toggle('util-SiteOverfloewd', true)
  }

  handleClose () {
    this.externalEls.modal.element.close()
    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  handleSelect () {
    this.externalEls?.table?.elements.forEach((tableEl) => {
      if (tableEl.dataset.url === this.externalEls.select.element.value) {
        tableEl.setAttribute('aria-current', true)
      } else {
        tableEl.setAttribute('aria-current', false)
      }
    })
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
